import { render } from "./BaseVideoModal.vue?vue&type=template&id=acdea700"
import script from "./BaseVideoModal.vue?vue&type=script&lang=js"
export * from "./BaseVideoModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__